<script>
  import {fade,fly} from 'svelte/transition';
  import {_} from 'svelte-i18n';
  export let trigger = true;
  import {sessionData} from '../stores.js'
  export let toggleStakeModal;


  $: visible = trigger

</script>

<style>
  .overlay {
    position: fixed;
    top: 0; left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index:9000;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    /* pointer-events: none; */
    transition: opacity 0.2s ease-in-out;
  }

  .modal {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    z-index:9001;
    /* justify-content: center; */
    width: 80%;
    max-width: 600px;
    /* height: 70vh; */
    padding: 40px;
    color: white;
    font-family: Brown;

    background-color: #262626;
    box-shadow: -26px 8px 32px 6px rgba(0,0,0,0.22);
    border-radius: 10px;
    transform: translateY(-50px);
    opacity: 1;
    transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  }
</style>

{#if $sessionData.stakeModal}
  <div transition:fly={{y:-20}} class="overlay" on:click={toggleStakeModal}>
    <div class="gap-y-4 modal text-4xl">
      <button on:click={toggleStakeModal}>
      <img  class="cursor-pointer w-8 absolute top-5 right-5" src="close_white.svg" on:click={toggleStakeModal} alt="close_white.svg" />
      </button>
      <h1>{$_("common.howDoes")}</h1>
      {#if $sessionData.selectedCard === "puzzle"}
        <p class="text-xl">{$_("puzzle.puzzleDescription")}</p>
      {:else}
        <p class="text-xl">{$_("gameplay.matchedOpponent")}</p>
        <p class="text-xl">{$_("gameplay.stake.total")}</p>
        <p class="text-xl">{$_("gameplay.stake.contribution")}</p>
        <p class="text-xl">{$_("gameplay.stake.weakerOpponent")}</p>
        <p class="text-xl">{$_("gameplay.stake.strongerOpponent")}</p>
      {/if}
      <p class="text-xl">{$_("gameplay.supportInfo")}</p>
    </div>
  </div>
{/if}
